import {
  COLLABORATION_FILTER_SUCCESS,
  COLLABORATION_DESI_ALL,
  COLLABORATION_DESI_SINGLE,
  FETCH_START,
  FETCH_END,
  COLLABORATION_DESI_LIST_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { toast } from 'react-toastify';
import { ServerError } from '../../../library/constants';
import { history } from '../../../components/Helpers';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
export const getCollaborationDesignerData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    getCollaborationDesignerAPI()
      .then((response) => {
        dispatch(getCollaborationDesignerSuccess(response.data.response));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCollaborationDesignerAPI = () => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('collaborations-access', { headers: headers });
};

export const getCollaborationDesignerSuccess = (data) => {
  return {
    type: COLLABORATION_DESI_ALL,
    data,
  };
};

// A single record lives in its own slot: sharing CollaborationData with the list
// would let the View/Edit pages render the list's first row until this lands, and
// would wipe the list the Collaboration Portal nav is built from.
export const getCollaborationDesignerById = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(getCollaborationDesignerByIdSuccess(null));
    getCollaborationDesignerByIdAPI(id)
      .then((response) => {
        // The endpoint answers with the bare record; tolerate a list envelope too.
        const data = response.data.response;
        dispatch(getCollaborationDesignerByIdSuccess(data?.records?.[0] ?? data ?? null));
        dispatch(fetchEnd());
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const getCollaborationDesignerByIdAPI = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  return axios.get('collaborations-access/' + id, { headers: headers });
};

export const getCollaborationDesignerByIdSuccess = (data) => {
  return {
    type: COLLABORATION_DESI_SINGLE,
    data,
  };
};

export const deleteCollaborationDesigner = (id) => {
  return (dispatch) => {
    deleteCollaborationDesignerApi(id)
      .then((response) => {
        dispatch(getCollaborationDesignerData());
        toast.success(response.data.response);
      })
      .catch((error) => { });
  };
};

const deleteCollaborationDesignerApi = (id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.delete('collaborations-access/' + id, { headers: headers });
  return result;
};

export const addCollaborationDesigner = (data, edit, id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    addCollaborationDesignerAPI(data, edit, id)
      .then((response) => {
        dispatch(fetchEnd());
        history.push('/collaboration-designer');
        toast.success(response.data.response);
      })
      .catch((error) => {
        dispatch(fetchEnd());
      });
  };
};

const addCollaborationDesignerAPI = (data, edit, id) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  for (var propName in data) {
    if (
      data[propName] === '' ||
      data[propName] === null ||
      data[propName] === undefined ||
      data[propName].length === 0 ||
      data[propName] === '1970-01-01T00:00:00.000Z,1970-01-01T00:00:00.000Z' ||
      data[propName] === '1970-01-01T00:00:00.000Z' ||
      data[propName] === ','
    ) {
      delete data[propName];
    }
  }
  if (edit === 'edit')
    result = axios.put('/collaborations-access/' + id, data, {
      headers: headers,
    });
  else
    result = axios.post('/collaborations-access', data, { headers: headers });
  return result;
};
